module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.f4faafb6.png";